import "./App.css";
import Cropper from "./components/Cropper";
// import ImageInput from "./components/ImageInput";
// import Navbar from "./components/Navbar";
function App() {
  return (
    <div>
      <h1>Image Cropper</h1>
      {/* <Navbar /> */}
      <Cropper />
      {/* <ImageInput /> */}
    </div>
  );
}

export default App;
